<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button (click)="cancel()" aria-label="Close" class="btn-close" type="button"></button>
</div>
<form (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)" [formGroup]="detailForm">
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="name-input">Name</label><span class="required"></span>
          <input
            class="form-control"
            formControlName="name"
            id="name-input"
            placeholder="Company name"
            type="text">
        </div>
        <dp-field-error [formField]="form['name']"></dp-field-error>
      </div>
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="code-input">Code</label><span class="required"></span>
          <input
            class="form-control"
            formControlName="code"
            id="code-input"
            placeholder="Code Number"
            type="text">
        </div>
        <dp-field-error [error]="['Code number is from 001 to 999']" [formField]="form['code']"></dp-field-error>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label" for="display-order-input">Display Order</label><span class="required"></span>
          <input
            class="form-control"
            formControlName="displayOrder"
            id="display-order-input"
            max="99"
            min="0"
            placeholder="Display Order Number"
            type="number">
        </div>
        <dp-field-error [error]="['Display Order number is from 01 to 99.']"
                        [formField]="form['displayOrder']"></dp-field-error>
      </div>
      <div *ngIf="purchasePlaceInfo" class="col-md-6">
        <div class="mb-3 position-relative d-flex flex-row">
          <label class="detail-item-label margin-right-15" for="display-input">Display</label>
          <div class="checkbox-container margin-right-15">
            <input (change)="setDisplayOptions($event)" formControlName="display" id="display-input" type="checkbox">
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="save btn btn-dark" type="submit">{{ saveButtonLabel }}</button>
    </div>
  </div>
</form>
